import clsx from "clsx";
import type { SVGProps } from "react";
import { type IconStyle, type IconName } from "@assets/icon/utils";
export { type IconStyle, type IconName } from "@assets/icon/utils";
import getIcon from "@assets/icon/client";


// globalThis.getIcon = (await import("@assets/icon/client")).default;
interface Props extends Omit<SVGProps<SVGSVGElement>, "style"> {
  className?: string;
  style?: IconStyle;
  name: IconName;
};

export default function Icon({className, style = "solid", name, ...props}:Props) {
  const id = `${style}:${name}`;
  if(!!globalThis.isServer) {
    if(!globalThis.SVGSprite) globalThis.SVGSprite = [];
    if(globalThis.SVGSprite.filter((_id:string) => _id===id).length === 0) globalThis.SVGSprite.push(id);
  } else {
    var sprite = document.querySelector('svg[data-id="SVGSprite"]') as HTMLElement | undefined;
    if(!document.getElementById(`${id}`) && !!sprite) {
      sprite.innerHTML = sprite.innerHTML + `<symbol viewBox="0 0 512 512" id="${id}"></symbol>`;
      var icon = getIcon({ style, name });
      icon?.then(i => {
        var t = document.getElementById(`${id}`);
        if(t) {
          Object.entries(i.attrs).forEach(([name, value]) => {
            if(/^viewbox$/i.test(name))
              t?.setAttribute(name, value);
          });
          t.innerHTML = i.innerHTML;
        }
        return i;
      });
    }
  }
  return <svg className={clsx("icon box-content", className)} {...props}><use xlinkHref={`#${id}`}/></svg>;
}